export type SubmissionItem = {
  field: string
  value: string
}

// Normalize various form values to strings so the Form Builder email templating
// reliably interpolates values (avoids `undefined`).
export function prepareSubmissionData(formData: Record<string, unknown>): SubmissionItem[] {
  const toStr = (val: unknown): string => {
    if (val === null || val === undefined) return ''
    if (typeof val === 'boolean') return val ? 'Yes' : 'No'
    if (Array.isArray(val)) {
      return val
        .map((item) => {
          if (item === null || item === undefined) return ''
          if (typeof item === 'object') {
            // Common shapes: { label, value } or arbitrary object
            const anyItem = item as Record<string, unknown>
            if (typeof anyItem.label === 'string') return anyItem.label
            if (typeof anyItem.value !== 'undefined') return String(anyItem.value)
            try {
              return JSON.stringify(item)
            } catch {
              return String(item)
            }
          }
          return String(item)
        })
        .filter(Boolean)
        .join(', ')
    }
    if (typeof val === 'object') {
      const anyVal = val as Record<string, unknown>
      // Support common select-like values
      if (typeof anyVal.label === 'string') return anyVal.label
      if (typeof anyVal.value !== 'undefined') return String(anyVal.value)
      try {
        return JSON.stringify(val)
      } catch {
        return String(val)
      }
    }
    return String(val)
  }

  return Object.entries(formData).map(([field, value]) => ({ field, value: toStr(value).trim() }))
}
